import React from 'react'
import { PopupWidget } from "react-calendly";
import { InlineWidget } from "react-calendly";
import { Helmet } from 'react-helmet-async'

function Booking() {
  
  return (
    <>
    <Helmet>
                  <title>Booking-NagsPro</title>
                  <meta name="description" content="Select a time slot that suits your schedule."/>
                  <link rel="canonical" href="/Booking"/>
                </Helmet>
  
    <div>
        <div className="container-fluid bg-primary py-5 mb-5 hero-header">
    <div className="container py-5">
      <div className="row justify-content-center py-5">
        <div className="col-lg-10 pt-lg-5 mt-lg-5 text-center">
          <h1 className="display-3 text-white animated slideInDown">Schedule a Meeting</h1>
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb justify-content-center">
              <li className="breadcrumb-item">
                <a href="/">Home</a>
              </li>
              <li
                className="breadcrumb-item text-white active"
                aria-current="page"
              >
                Booking
              </li>
            </ol>
          </nav>
        </div>
      </div>
    </div>
  </div>
      {/* Process Start */}
      <div className="container-xxl py-5">
      <div className="container">
        <div className="text-center pb-4 wow fadeInUp" data-wow-delay="0.1s">
          <h6 className="section-title bg-white text-center text-primary px-3">
            Process
          </h6>
          <h1 className="mb-5">3 Easy Steps</h1>
        </div>
        <div className="row gy-5 gx-4 justify-content-center">
          <div
            className="col-lg-4 col-sm-6 text-center pt-4 wow fadeInUp"
            data-wow-delay="0.1s"
          >
            <div className="position-relative border border-primary pt-5 pb-4 px-4">
              <div
                className="d-inline-flex align-items-center justify-content-center bg-primary rounded-circle position-absolute top-0 start-50 translate-middle shadow"
                style={{ width: 100, height: 100 }}
              >
                <i className="fa fa-globe fa-3x text-white" />
              </div>
              <h5 className="mt-4">Visit the NagsPro Website</h5>
              <hr className="w-25 mx-auto bg-primary mb-1" />
              <hr className="w-50 mx-auto bg-primary mt-0" />
              <p className="mb-0">
              Open your web browser and go to the official NagsPro website.
              Look for a section labeled <b>Schedule a Meeting</b>. 
              This is typically found in the main navigation menu or as a prominent button on the homepage.
              </p>
            </div>
          </div>
          <div
            className="col-lg-4 col-sm-6 text-center pt-4 wow fadeInUp"
            data-wow-delay="0.3s"
          >
            <div className="position-relative border border-primary pt-5 pb-4 px-4">
              <div
                className="d-inline-flex align-items-center justify-content-center bg-primary rounded-circle position-absolute top-0 start-50 translate-middle shadow"
                style={{ width: 100, height: 100 }}
              >
                <i className="fa fa-calendar-alt fa-3x text-white" />
              </div>
              <h5 className="mt-4">Pick a Date and Time</h5>
              <hr className="w-25 mx-auto bg-primary mb-1" />
              <hr className="w-50 mx-auto bg-primary mt-0" />
              <p className="mb-0">
                <li>The Calender widget will display available dates on a calendar.</li>
                <li>Click on a preferred date to view available time slots.</li>
                <li>Select a time slot that suits your schedule.</li>
             

              </p>
            </div>
          </div>
          <div
            className="col-lg-4 col-sm-6 text-center pt-4 wow fadeInUp"
            data-wow-delay="0.5s"
          >
            <div className="position-relative border border-primary pt-5 pb-4 px-4">
              <div
                className="d-inline-flex align-items-center justify-content-center bg-primary rounded-circle position-absolute top-0 start-50 translate-middle shadow"
                style={{ width: 100, height: 100 }}
              >
                <i className="fa fa-list-alt fa-3x text-white" />
              </div>
              <h5 className="mt-4">Fill in Your Details</h5>
              <hr className="w-25 mx-auto bg-primary mb-1" />
              <hr className="w-50 mx-auto bg-primary mt-0" />
              <p className="mb-0">
              <li>Provide your name, email address, and any additional information required.</li>
              <li>If there's a message or notes section, you can add details about your meeting objectives or queries.</li>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    {/* Process Start */}


    <div className="App" data-wow-delay="0.5s">
      <InlineWidget url="https://calendly.com/nagspros" />
    </div>
    </div>
    </>
  )
}

export default Booking
